import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function PlatformAuditLog() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/platform/audit-log", { params: { limit: 500 } })
      .then((r) => setEntries(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="platform-audit-page">
      <header>
        <p className="text-[11px] uppercase tracking-widest text-amber-300/80 font-bold">Platform</p>
        <h1 className="mt-1 text-3xl font-heading font-semibold tracking-tight">Audit log</h1>
        <p className="mt-1 text-sm text-white/60">
          Every platform-level action (impersonation, note creation, agency visit) — append-only.
        </p>
      </header>

      {loading ? (
        <div className="flex items-center justify-center py-16 text-white/60">
          <Loader2 className="h-5 w-5 animate-spin mr-2" /> Loading…
        </div>
      ) : entries.length === 0 ? (
        <div className="rounded-xl bg-white/5 border border-white/10 p-10 text-center text-white/60">
          No events yet.
        </div>
      ) : (
        <div className="rounded-xl bg-white/5 border border-white/10 overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-[11px] uppercase tracking-wider text-white/40 bg-white/[0.03]">
                <th className="text-left px-4 py-2.5 font-medium">When</th>
                <th className="text-left px-3 py-2.5 font-medium">Action</th>
                <th className="text-left px-3 py-2.5 font-medium">Actor</th>
                <th className="text-left px-3 py-2.5 font-medium">Agency</th>
                <th className="text-left px-3 py-2.5 font-medium">IP</th>
                <th className="text-left px-3 py-2.5 font-medium">Details</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {entries.map((e) => (
                <tr key={e.id} className="hover:bg-white/[0.04]">
                  <td className="px-4 py-2 text-xs text-white/60 tabular-nums">
                    {new Date(e.created_at).toLocaleString()}
                  </td>
                  <td className="px-3 py-2 text-amber-200 font-medium">{e.action}</td>
                  <td className="px-3 py-2 text-white/80 truncate">{e.actor_email}</td>
                  <td className="px-3 py-2 text-white/60 text-xs">
                    {e.target_agency_id ? (
                      <Link to={`/platform/agencies/${e.target_agency_id}`} className="hover:text-white">
                        {e.target_agency_id.slice(0, 8)}…
                      </Link>
                    ) : "—"}
                  </td>
                  <td className="px-3 py-2 text-white/40 text-xs font-mono">{e.ip || "—"}</td>
                  <td className="px-3 py-2 text-white/50 text-xs truncate max-w-xs">
                    {e.details && Object.keys(e.details).length > 0
                      ? JSON.stringify(e.details).slice(0, 80)
                      : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
